import { Cell } from '@pelckmans/elementis/components/table';
import { ComponentProps } from 'react';
import { AdaptiveAssessmentQExercise } from '../../../../../../api/medialink';
import { SCORE_STATUS } from '../../../../../../constants/ScoreStatus';
import { getResultPercentages } from '../../../../../../utils/results';

interface Props extends Pick<AdaptiveAssessmentQExercise, 'phases' | 'isLastPhase'> {
  quantifiable: boolean;
  status?: typeof SCORE_STATUS[keyof typeof SCORE_STATUS];
  score: {
    maximum: number;
    achievable: number;
    achieved: number;
  };
  needsGrading?: boolean;
}

export default function ResultsCell({ quantifiable, status, phases, isLastPhase, score, needsGrading }: Props) {
  const props: Partial<ComponentProps<typeof Cell.Results>> = {
    status: status,
    showTooltip: true,
    variant: 'donut',
    ...((phases || []).length && {
      adaptivePhases: (phases || []).map(x => ({
        ...x,
        score: getResultPercentages(x.score),
      })),
    }),
    isLastPhase: Boolean(isLastPhase),
  };

  if (quantifiable) {
    return <Cell.Results {...props} {...getResultPercentages(score, needsGrading)} quantifiable />;
  }

  return <Cell.Results {...props} quantifiable={false} />;
}
